import React, { useState } from "react";
import { FaChevronRight } from "react-icons/fa";

function FilterSelector({ activeDuration, setActiveDuration }) {
  const [slideButtons, setSlideButtons] = useState(false);

  //   const btns = ["Current Month", "Previous Month", "Last 3 Months"];
  const btns = [
    {
      name: "Current Month",
      value: "current_month_summary",
    },
    {
      name: "Previous Month",
      value: "past_month_summary",
    },
    {
      name: "Last 3 Months",
      value: "last_3_month_summary",
    },
  ];
  //   const btnsExtra = ["Last 6 Months", "Last 1 Year", "Overall"];
  const btnsExtra = [
    {
      name: "Last 6 Months",
      value: "last_6_month_summary",
    },
    {
      name: "Last 1 Year",
      value: "last_1_year_summary",
    },
    {
      name: "Overall",
      value: "overall_summary",
    },
  ];
  return (
    <div
      className={`flex  bg-[#f1f1f6] rounded-[12px] p-[2px] px-[3px] items-center h-[25px] w-fit mt-4 mx-auto transition-all duration-300 ease-in-out ${
        slideButtons ? "scale-100" : " scale-[.99]"
      }`}
    >
      {slideButtons && (
        <button
          className={` w-4 h-4 flex items-center justify-center text-[#00394d]`}
          onClick={() => setSlideButtons(false)}
        >
          <FaChevronRight
            size={10}
            style={{
              transform: `rotate(${slideButtons ? 180 : 0}deg)`,
            }}
          />
        </button>
      )}
      {!slideButtons &&
        btns.map((btn, index) => (
          <button
            key={index}
            className={`${
              activeDuration === btn.value
                ? "bg-[#a0ff77] text-[#262626]"
                : "bg-[#f1f1f6] text-[#848484]"
            } text-xs rounded-[10px] px-3 py-[2px] mx-[2px] transition-all duration-200 ease-in-out`}
            onClick={() => setActiveDuration(btn.value)}
          >
            {btn.name}
          </button>
        ))}

      {slideButtons &&
        btnsExtra.map((btn, index) => (
          <button
            key={index}
            className={`${
              activeDuration === btn.value
                ? "bg-[#a0ff77] text-[#262626]"
                : "bg-[#f1f1f6] text-[#848484]"
            } text-xs rounded-[10px] px-3 py-[2px] mx-[2px] transition-all duration-200 ease-in-out`}
            onClick={() => setActiveDuration(btn.value)}
          >
            {btn.name}
          </button>
        ))}
      {!slideButtons && (
        <button
          className={` w-4 h-4 flex items-center justify-center text-[#00394d]`}
          onClick={() => setSlideButtons(true)}
        >
          <FaChevronRight size={10} />
        </button>
      )}
    </div>
  );
}

export default FilterSelector;
